import { DESKTOP_MIN_WIDTH, MOBILE_MAX_WIDTH, TABLET_MAX_WIDTH, TABLET_MIN_WIDTH } from './responsive-devices.consts';
import { Fragment, FunctionComponent } from 'preact';
import { h } from 'preact';
import Media from 'react-media';

interface Props {
	children: any;
}

export const Desktop: FunctionComponent<Props> = ({ children }) => {
	return <Media data-testid="desktop" query={`(min-width: ${DESKTOP_MIN_WIDTH}px)`} render={() => children} />;
};

export const Tablet: FunctionComponent<Props> = ({ children }) => {
	return (
		<Media
			data-testid="tablet"
			query={`(min-width: ${TABLET_MIN_WIDTH}px) and (max-width: ${TABLET_MAX_WIDTH}px)`}
			render={() => children}
		/>
	);
};

export const Mobile: FunctionComponent<Props> = ({ children }) => {
	return <Media data-testid="mobile" query={`(max-width: ${MOBILE_MAX_WIDTH}px)`} render={() => children} />;
};

export const MobileAndTablet: FunctionComponent<Props> = ({ children }) => {
	return (
		<Fragment>
			<Tablet>{children}</Tablet>
			<Mobile>{children}</Mobile>
		</Fragment>
	);
};

export const TabletAndDesktop: FunctionComponent<Props> = ({ children }) => {
	return (
		<Fragment>
			<Tablet>{children}</Tablet>
			<Desktop>{children}</Desktop>
		</Fragment>
	);
};
